import { useLayoutContext } from "client/components/layout"
import { Voting_Question } from "client/graphql"
import {
  Plugin,
  useGlobalContext,
} from "client/packages/utils/GlobalContext"
import { RozyLayout } from "shared/constants/views"
import { P } from "shared/styles/textStyles"
import styled, { css } from "styled-components"

import VotingButton from "./VotingButton"
import { useVotingContext } from "./VotingContext"

const Wrapper = styled.div<{ $isMobileLayout: boolean }>`
  height: 100%;
  width: 100%;
  line-height: normal;
  display: flex;
  justify-content: center;

  ${P} {
    color: ${(props) => props.theme.colors.white};
    margin: 10px auto;
    text-align: center;
    font-size: ${(props) => props.theme.voting.questionFontSize};
    max-width: 60%;
    font-family: ${(props) => props.theme.voting.font};
    font-weight: ${(props) => props.theme.voting.fontWeight};
    font-style: ${(props) => props.theme.voting.fontStyle};

    ${(props) =>
      props.$isMobileLayout &&
      css`
        margin: 20px auto;
        max-width: 80%;
      `}
  }
`

const AnswersWrapper = styled.div<{
  $selectedAnswer: string
  $isMobileLayout: boolean
}>`
  list-style-type: none;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  width: 800px;
  max-width: 100%;

  @media (min-width: 1670px) {
    width: 100%;
  }

  ${(props) =>
    props.$selectedAnswer &&
    css`
      & > button {
        pointer-events: none;

        p {
          pointer-events: none;
        }
      }
    `}
`

export type QuestionProps = {
  question: Voting_Question
  selectedAnswerId: string
}

const QuestionPanel = ({ question, selectedAnswerId }: QuestionProps) => {
  const { setPluginOpen } = useGlobalContext()
  const { activeQuestion, castVote } = useVotingContext()

  const { layout } = useLayoutContext()

  return (
    <Wrapper $isMobileLayout={layout === RozyLayout.MOBILE}>
      <AnswersWrapper
        $selectedAnswer={selectedAnswerId}
        $isMobileLayout={layout === RozyLayout.MOBILE}
      >
        {question.answers.map((answer) => (
          <VotingButton
            key={answer.id}
            onClick={() => {
              castVote(answer.id)
              if (activeQuestion.maxVotesAllowed === 1) {
                setPluginOpen(Plugin.VOTING, false)
              }
            }}
            isSelected={answer.id === selectedAnswerId}
            disabled={!!selectedAnswerId}
            showAnimation={question.maxVotesAllowed !== 1}
          >
            {answer.text}
          </VotingButton>
        ))}
      </AnswersWrapper>
    </Wrapper>
  )
}

export default QuestionPanel
